// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'proforma-invoice.page.title': 'Pro Forma Invoices',
    'proforma-invoice.page.title.duplicate': 'Duplicate Invoice',
    'proforma-invoice.page.create.title': 'New Pro Forma Invoice',
    'proforma-invoice.page.search.title': 'Find Pro Forma Invoices',
    'proforma-invoice.page.convert.title': 'Convert to Invoice',
    'proforma-invoice.page.edit.title': 'Edit Pro Forma Invoice',
    'proforma-invoice.page.edit.email': 'Email Pro Forma Invoice',

    'proforma-invoice.button.find': 'Find Pro Forma Invoices',
    'proforma-invoice.button.create': 'Save',
    'proforma-invoice.button.convert': 'Convert to Invoice',
    'proforma-invoice.button.new': 'New Pro Forma Invoice',
    'proforma-invoice.button.cancel_invoice': 'Void Pro Forma Invoice',
    'proforma-invoice.button.duplicate': 'Duplicate',

    'proforma-invoice.placeholder.search': 'Search pro forma invoices',

    'proforma-invoice.message.no_change': 'This pro forma invoice has not changed since it was created.',

    'proforma-invoice.link.create_first_invoice': 'Click here to create your first pro forma invoice',
    'proforma-invoice.link.invoices': ' Return to Pro Forma Invoices',

    'proforma-invoice.label.cancelled_proforma_invoice': 'Cancelled Pro Forma Invoice',
    'proforma-invoice.label.void_reason': 'Reason for voiding pro forma invoice',
    'proforma-invoice.label.proforma_invoice_number': 'Pro Forma Invoice No',
    'proforma-invoice.label.draft_proforma_invoice': 'Draft Pro Forma Invoice',

    'proforma-invoice.modal.title.proforma_invoice_cancel': 'Void Pro Forma Invoice',

    'proforma-invoice.modal.message.proforma_invoice_cancel':
        'Are you sure that you want to void this pro forma invoice? This action cannot be undone. | Are you sure that you want to void these pro forma invoices? This action cannot be undone.',

    'proforma-invoice.success.message.proforma_invoice_created': 'Your pro forma invoice has been created',
    'proforma-invoice.success.message.proforma_invoice_updated': 'Your pro forma invoice has been updated',
    'proforma-invoice.success.message.proforma_invoice_converted': 'Your pro forma invoice was successfully converted.',
};
